import type { OrderStatus } from "../../../components/common/chip";

/**
 * ═══════════════════════════════════════════════════════════════════════
 * CRITICAL: Order Status Flow — DO NOT CHANGE without product confirmation.
 * ═══════════════════════════════════════════════════════════════════════
 *
 * Seller PO view:  processing → inTransit → delivered → validated
 *
 *  - "processing": PO exists (state=purchase). Seller has NOT yet shipped.
 *  - "inTransit":  Seller clicked "Mark as Shipped" (sellerShipped=true on
 *                  the linked sale order, exposed on the PO detail DTO).
 *  - "delivered":  Seller clicked "Mark as Delivered" (picking state=done).
 *  - "validated":  Buyer clicked "Mark as Received" (confirmedByBuyer=true).
 *
 * IMPORTANT: Do NOT derive inTransit from picking state, datePlanned, or
 * pickingId — Odoo sets those automatically at SO confirmation, before the
 * seller does anything. Only `sellerShipped` is a safe signal.
 * ═══════════════════════════════════════════════════════════════════════
 */
type PurchaseOrderStatusSource = {
  state: string;
  sellerShipped?: boolean | null;
  deliveredAt?: string | null;
  dropshipping?: { id: number; state?: string | null; confirmedByBuyer?: boolean | null }[] | null;
};

export function mapPoStatus(po: PurchaseOrderStatusSource): OrderStatus {
  if (po.state === "cancel") return "cancelled";
  if (po.dropshipping?.some((d) => d.confirmedByBuyer)) return "validated";
  if (po.deliveredAt) return "delivered";
  if (po.state === "done") return "delivered";
  if (po.dropshipping?.some((d) => d.state === "done")) return "delivered";
  if (po.sellerShipped) return "inTransit";
  if (po.state === "purchase") return "processing";
  return "processing";
}
